module.exports = __webpack_public_path__ + "media/property_transaction_process/business-agent-09690e59.svg";